(function () {
  'use strict';

  const triggerSelector = '[data-mega-menu-trigger]';

  // Everything below used to run at top level against a server-rendered
  // #megaMenu. The panel is now fetched lazily (see the bootstrap at the end
  // of this file), so the whole init is wrapped in a function that runs
  // either at load (inline panel: theme editor / marker path) or right after
  // the fetched panel is appended to <body>.
  function initMegaMenu(menu) {
  const triggers = Array.from(document.querySelectorAll(triggerSelector));
  const closeButton = menu.querySelector('[data-mega-menu-close]');
  const scopeList = menu.querySelector('[data-mega-scopes]');
  const scopeTabs = Array.from(menu.querySelectorAll('[data-mega-scopes] [data-mega-scope]'));
  const lists = {
    categories: menu.querySelector('[data-mega-list="categories"]'),
    licensed: menu.querySelector('[data-mega-list="licensed"]'),
    creators: menu.querySelector('[data-mega-list="creators"]'),
  };
  const parallaxLayers = Array.from(menu.querySelectorAll('[data-mega-parallax]'));
  const bgSlots = {
    a: menu.querySelector('[data-mega-bg-slot="a"]'),
    b: menu.querySelector('[data-mega-bg-slot="b"]'),
  };
  const ghostWrap = menu.querySelector('[data-mega-ghost]');
  const ghostBank = menu.querySelector('.mega-menu__ghost-bank');
  const titleEl = menu.querySelector('[data-mega-title]');
  const kickEl = menu.querySelector('[data-mega-kick]');
  const chipEl = menu.querySelector('[data-mega-chip]');
  const stageCta = menu.querySelector('[data-mega-stage-cta]');
  const fanRoot = menu.querySelector('[data-mega-fan]');
  const fanLink = menu.querySelector('[data-mega-fan-link]');
  const fanArt = menu.querySelector('[data-mega-fan-art]');
  const fanName = menu.querySelector('[data-mega-fan-name]');
  const fanCaption = menu.querySelector('[data-mega-fan-caption]');
  const tickerLabel = menu.querySelector('[data-mega-ticker-label]');
  const tickerTrack = menu.querySelector('[data-mega-ticker-track]');
  const mobileHero = menu.querySelector('[data-mega-mobile-hero]');
  const mobileName = menu.querySelector('[data-mega-mobile-name]');
  const mobileMeta = menu.querySelector('[data-mega-mobile-meta]');
  const mobileThumb = menu.querySelector('[data-mega-mobile-thumb]');
  const listsScroll = menu.querySelector('.mega-menu__lists');
  const endingWrap = menu.querySelector('[data-mega-ending]');
  const endingRows = Array.from(menu.querySelectorAll('[data-mega-ending-row]'));
  const countdownEls = Array.from(menu.querySelectorAll('[data-mega-countdown]'));
  const stagePanel = menu.querySelector('[data-mega-stage]');
  const stageCopy = menu.querySelector('.mega-menu__stage-copy');

  const strings = {
    deskmatsLive: menu.getAttribute('data-str-deskmats-live') || 'deskmats live',
    officiallyLicensed: menu.getAttribute('data-str-officially-licensed') || 'Officially licensed',
    creatorCollab: menu.getAttribute('data-str-creator-collab') || 'Creator collab',
    containsMatsFrom: menu.getAttribute('data-str-contains-mats-from') || 'contains mats from',
    matsAppearIn: menu.getAttribute('data-str-mats-appear-in') || 'mats appear in',
    freshIn: menu.getAttribute('data-str-fresh-in') || 'Fresh in {{ name }} · auto-rotates',
    limitedEdition: menu.getAttribute('data-str-limited-edition') || 'Limited edition',
    dropEndsIn: menu.getAttribute('data-str-drop-ends-in') || 'Drop ends in',
    shopAll: menu.getAttribute('data-str-shop-all') || 'Shop all',
    shopName: menu.getAttribute('data-str-shop-name') || 'Shop __NAME__',
    liveNow: menu.getAttribute('data-str-live-now') || 'Live now',
    ended: menu.getAttribute('data-str-ended') || 'Ended',
  };
  const collectionsUrl = menu.getAttribute('data-collections-url') || '/collections';

  const hoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const hoverIntentDelay = 55;
  const exitDuration = 300;
  const fanIntervalMs = 3200;
  const bgIntervalMs = 6500;

  let isOpen = false;
  let isExiting = false;
  let currentOpener = null;
  let previousBodyOverflow = '';
  let hoverTimer = null;
  let exitTimer = null;
  let fanTimer = null;
  let bgTimer = null;
  let countdownTimer = null;
  let currentScope = 'categories';
  let activeRow = null;
  let fanIndex = 0;
  let fanItems = [];
  let fanFallbackUrl = collectionsUrl;
  let fanFallbackLabel = strings.shopAll;
  let bgSources = [];
  let bgIndex = 0;
  let bgActiveSlot = 'a';
  let currentBgUrl = '';
  const remembered = { categories: null, licensed: null, creators: null };

  const motion = {
    stageX: 0,
    stageY: 0,
    stageTX: 0,
    stageTY: 0,
    closeX: 0,
    closeY: 0,
    closeTX: 0,
    closeTY: 0,
  };
  let rafId = null;

  function fancyMotionEnabled() {
    return hoverQuery.matches && !motionQuery.matches;
  }

  function lerp(current, target, rate) {
    const next = current + (target - current) * rate;
    return Math.abs(target - next) < 0.01 ? target : next;
  }

  function motionFrame() {
    motion.stageX = lerp(motion.stageX, motion.stageTX, 0.1);
    motion.stageY = lerp(motion.stageY, motion.stageTY, 0.1);
    motion.closeX = lerp(motion.closeX, motion.closeTX, 0.2);
    motion.closeY = lerp(motion.closeY, motion.closeTY, 0.2);

    const mediaTranslate =
      (motion.stageX * 24).toFixed(2) + 'px ' + (motion.stageY * 16).toFixed(2) + 'px';
    const ghostTranslate =
      (motion.stageX * -34).toFixed(2) + 'px ' + (motion.stageY * -20).toFixed(2) + 'px';

    parallaxLayers.forEach(function (layer) {
      layer.style.translate = mediaTranslate;
    });
    if (ghostWrap) ghostWrap.style.translate = ghostTranslate;
    if (closeButton) {
      closeButton.style.setProperty('--mm-close-x', motion.closeX.toFixed(2) + 'px');
      closeButton.style.setProperty('--mm-close-y', motion.closeY.toFixed(2) + 'px');
    }

    /* Stop once every axis has reached its target instead of spinning for the
       whole time the menu is open. lerp() snaps exactly to target inside 0.01,
       so "settled" is an equality test, and the resting frame above has already
       been written by the time we get here.

       This matters more than a normal idle rAF: the frame writes `translate` on
       each parallax layer AND two custom properties on the close button (which
       invalidates style for its subtree), all of it underneath two
       backdrop-filter: blur() panels that must re-blur their backdrop whenever
       anything below them moves. Every pointermove restarts the loop, so motion
       is unchanged — it just costs nothing while the pointer is still. */
    const settled =
      motion.stageX === motion.stageTX &&
      motion.stageY === motion.stageTY &&
      motion.closeX === motion.closeTX &&
      motion.closeY === motion.closeTY;

    rafId =
      !settled && isOpen && fancyMotionEnabled()
        ? window.requestAnimationFrame(motionFrame)
        : null;
  }

  function startMotionLoop() {
    if (rafId === null && isOpen && fancyMotionEnabled()) {
      rafId = window.requestAnimationFrame(motionFrame);
    }
  }

  function stopMotionLoop() {
    if (rafId !== null) {
      window.cancelAnimationFrame(rafId);
      rafId = null;
    }
  }

  function resetMotionSurfaces() {
    stopMotionLoop();
    motion.stageX = motion.stageY = motion.stageTX = motion.stageTY = 0;
    motion.closeX = motion.closeY = motion.closeTX = motion.closeTY = 0;
    parallaxLayers.forEach(function (layer) {
      layer.style.removeProperty('translate');
    });
    if (ghostWrap) ghostWrap.style.removeProperty('translate');
    if (closeButton) {
      closeButton.style.removeProperty('--mm-close-x');
      closeButton.style.removeProperty('--mm-close-y');
    }
  }

  function clearHoverTimer() {
    if (hoverTimer !== null) {
      window.clearTimeout(hoverTimer);
      hoverTimer = null;
    }
  }

  function clearExitTimer() {
    if (exitTimer !== null) {
      window.clearTimeout(exitTimer);
      exitTimer = null;
    }
  }

  function clearFanTimer() {
    if (fanTimer !== null) {
      window.clearInterval(fanTimer);
      fanTimer = null;
    }
  }

  function clearBgTimer() {
    if (bgTimer !== null) {
      window.clearInterval(bgTimer);
      bgTimer = null;
    }
  }

  function clearCountdownTimer() {
    if (countdownTimer !== null) {
      window.clearInterval(countdownTimer);
      countdownTimer = null;
    }
  }

  function dispatchMenuEvent(name) {
    document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
  }

  function pad2(n) {
    return String(n).padStart(2, '0');
  }

  function parseEnds(value) {
    if (!value) return NaN;
    const t = new Date(value).getTime();
    return Number.isNaN(t) ? NaN : t;
  }

  function formatCountdown(diff, format) {
    if (diff <= 0) return format === 'hours' ? strings.ended : '0D 00:00:00';
    if (format === 'hours') {
      const h = Math.floor(diff / 3600000);
      if (h < 1) return Math.floor(diff / 60000) + ' min left';
      return h + ' hours left';
    }
    const days = Math.floor(diff / 86400000);
    const hours = Math.floor((diff % 86400000) / 3600000);
    const mins = Math.floor((diff % 3600000) / 60000);
    const secs = Math.floor((diff % 60000) / 1000);
    return days + 'D ' + pad2(hours) + ':' + pad2(mins) + ':' + pad2(secs);
  }

  function tickCountdowns() {
    const now = Date.now();
    countdownEls.forEach(function (el) {
      const ends = parseEnds(el.getAttribute('data-ends'));
      if (Number.isNaN(ends)) {
        el.textContent = '';
        return;
      }
      el.textContent = formatCountdown(ends - now, el.getAttribute('data-format') || 'full');
    });
  }

  function startCountdowns() {
    tickCountdowns();
    clearCountdownTimer();
    if (!countdownEls.length || motionQuery.matches) return;
    countdownTimer = window.setInterval(tickCountdowns, 1000);
  }

  function sortEndingRows() {
    if (!endingWrap || !endingRows.length) return;
    const parent = endingWrap.querySelector('[data-mega-ending-rows]');
    if (!parent) return;
    const now = Date.now();
    const sorted = endingRows
      .map(function (row) {
        return { row: row, ends: parseEnds(row.getAttribute('data-ends')) };
      })
      .filter(function (item) {
        return !Number.isNaN(item.ends) && item.ends > now;
      })
      .sort(function (a, b) {
        return a.ends - b.ends;
      })
      .slice(0, 3);

    endingRows.forEach(function (row) {
      row.hidden = true;
    });
    if (!sorted.length) {
      endingWrap.hidden = true;
      return;
    }
    endingWrap.hidden = false;
    sorted.forEach(function (item) {
      item.row.hidden = false;
      parent.appendChild(item.row);
    });
  }

  function rowsForScope(scope, options) {
    const list = lists[scope];
    if (!list) return [];
    const visibleOnly = !options || options.visibleOnly !== false;
    return Array.from(list.querySelectorAll('[data-mega-row]')).filter(function (row) {
      if (!visibleOnly) return true;
      const item = row.closest('.mega-menu__row-item');
      return !item || !item.hasAttribute('hidden');
    });
  }

  function allRowsForScope(scope) {
    return rowsForScope(scope, { visibleOnly: false });
  }

  function parseJsonAttr(el, name, fallback) {
    const raw = el.getAttribute(name);
    if (!raw) return fallback;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return fallback;
    }
  }

  // The mobile hero thumb renders at most 8.4rem wide and its container is
  // display:none outside the mobile breakpoint, but it reuses the fan `src`,
  // which is sized for the full-size fan art (width=900). Left as-is the
  // browser eagerly pulled ~83KB per page view for a 69px-wide thumbnail that
  // desktop never shows. Re-point the Shopify CDN transform at the size the
  // thumb actually needs; anything without a `width` param is left untouched.
  const THUMB_WIDTH = 200;

  /*
   * Liquid writes these values with `| escape`, but getAttribute() returns them
   * ENTITY-DECODED — so `&lt;img&gt;` comes back as `<img>` and the Liquid
   * escaping buys nothing once the value is concatenated into innerHTML below.
   * Only merchant-set section settings feed these today, so this is hardening
   * rather than an open hole, but the markup is built by string concat and must
   * escape at the point of use. Attribute values additionally escape quotes.
   */
  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function escAttr(value) {
    return esc(value).replace(/"/g, '&quot;');
  }

  function thumbSrc(src) {
    if (!src) return '';
    return String(src).replace(/([?&]width=)\d+/, '$1' + THUMB_WIDTH);
  }

  // Hidden while the menu is closed, so `lazy` keeps the fetch off the critical
  // path entirely until the menu is actually opened on a mobile viewport.
  function thumbMarkup(src) {
    const resized = thumbSrc(src);
    return resized
      ? '<img src="' + escAttr(resized) + '" alt="" loading="lazy" decoding="async">'
      : '';
  }

  // Mirrors snippets/ed-art-title.liquid / card-product: "{Art} — {IP} {Type}"
  // → art name only (no quotes). Preview + fan labels re-quote for display.
  function parseArtTitle(raw) {
    if (!raw) return '';
    let art = String(raw);
    if (art.indexOf(' — ') !== -1) {
      art = art.split(' — ')[0].trim();
    } else {
      const norm = art.replace(/[\u201C\u201D\u201E]/g, '"');
      const parts = norm.split('"');
      if (parts.length >= 3) art = parts[1].trim();
    }
    return art.replace(/[\u201C\u201D\u201E"]/g, '').trim();
  }

  function quotedArtTitle(raw) {
    const art = parseArtTitle(raw);
    return art ? '\u201C' + art + '\u201D' : '';
  }

  function normalizeFanItems(raw) {
    if (!Array.isArray(raw)) return [];
    return raw
      .map(function (item) {
        if (!item) return null;
        if (typeof item === 'string') return { src: item, title: '', kind: '', hoverSrc: '', url: '' };
        if (typeof item === 'object' && item.src) {
          return {
            src: String(item.src),
            title: item.kind === 'logo'
              ? String(item.title || '')
              : parseArtTitle(item.title ? String(item.title) : ''),
            kind: item.kind ? String(item.kind) : '',
            hoverSrc: item.hoverSrc ? String(item.hoverSrc) : '',
            url: item.url ? String(item.url) : '',
          };
        }
        return null;
      })
      .filter(Boolean);
  }

  function normalizeBgSources(raw, fanList) {
    const fanUrls = {};
    (fanList || []).forEach(function (item) {
      if (item && item.src) fanUrls[item.src] = true;
    });
    const list = Array.isArray(raw)
      ? raw
          .map(function (item) {
            return typeof item === 'string' ? item : item && item.src ? String(item.src) : '';
          })
          .filter(Boolean)
      : [];
    const distinct = list.filter(function (url) {
      return !fanUrls[url];
    });
    return distinct.length ? distinct : list;
  }

  function setBgPhoto(slotEl, url, active) {
    if (!slotEl) return;
    if (url) {
      slotEl.style.backgroundImage = 'url("' + url.replace(/"/g, '\\"') + '")';
    } else {
      slotEl.style.removeProperty('background-image');
    }
    slotEl.classList.toggle('is-active', !!active);
    slotEl.classList.remove('is-entering');
  }

  function paintBg(url, animate) {
    if (!bgSlots.a || !bgSlots.b) return;
    if (!url) {
      setBgPhoto(bgSlots.a, '', false);
      setBgPhoto(bgSlots.b, '', false);
      currentBgUrl = '';
      return;
    }
    if (url === currentBgUrl && !animate) return;

    const nextSlotKey = bgActiveSlot === 'a' ? 'b' : 'a';
    const nextSlot = bgSlots[nextSlotKey];
    const prevSlot = bgSlots[bgActiveSlot];

    setBgPhoto(nextSlot, url, false);
    if (animate && !motionQuery.matches && currentBgUrl) {
      nextSlot.classList.add('is-entering');
      nextSlot.classList.add('is-active');
      prevSlot.classList.remove('is-active');
      window.setTimeout(function () {
        nextSlot.classList.remove('is-entering');
      }, 1600);
    } else {
      setBgPhoto(nextSlot, url, true);
      if (prevSlot !== nextSlot) prevSlot.classList.remove('is-active');
    }
    bgActiveSlot = nextSlotKey;
    currentBgUrl = url;
  }

  // The first couple of shots in a collection's list are usually packshots or
  // detail crops; the third or fourth is typically the wide styled scene that
  // actually reads as a backdrop. Start there when the collection has enough
  // images, and walk forward from it so each change is a visibly different shot
  // rather than a random pick that can repeat.
  function preferredBgStart() {
    if (bgSources.length >= 4) return 2 + Math.floor(Math.random() * 2);
    return bgSources.length > 1 ? 1 : 0;
  }

  function preloadBg(url) {
    if (!url) return;
    const img = new Image();
    img.decoding = 'async';
    img.src = url;
  }

  function nextBgUrl() {
    if (!bgSources.length) return '';
    if (bgSources.length === 1) return bgSources[0];
    bgIndex = (bgIndex + 1) % bgSources.length;
    if (bgSources[bgIndex] === currentBgUrl) {
      bgIndex = (bgIndex + 1) % bgSources.length;
    }
    // Warm the one after this so the next crossfade is not waiting on network.
    preloadBg(bgSources[(bgIndex + 1) % bgSources.length]);
    return bgSources[bgIndex];
  }

  function startBgRotation(reset) {
    clearBgTimer();
    if (!bgSources.length) {
      paintBg('', false);
      return;
    }
    // Same reason as startFan: assigning background-image on a hidden slot is
    // still a network fetch. Measured 125-330 KB per image on page load with
    // the menu closed. Defer to openMenu().
    if (!isOpen) return;
    if (reset || !currentBgUrl || bgSources.indexOf(currentBgUrl) === -1) {
      bgIndex = preferredBgStart();
      paintBg(bgSources[bgIndex], false);
      preloadBg(bgSources[(bgIndex + 1) % bgSources.length]);
    }
    if (motionQuery.matches || bgSources.length < 2 || !isOpen) return;
    bgTimer = window.setInterval(function () {
      paintBg(nextBgUrl(), true);
    }, bgIntervalMs);
  }

  function setGhost(key, isCategory) {
    if (!ghostWrap) return;
    ghostWrap.innerHTML = '';
    if (!isCategory || !ghostBank) return;
    const src = ghostBank.querySelector('[data-mega-ghost-src="' + key + '"]');
    if (!src) return;
    ghostWrap.appendChild(src.cloneNode(true));
  }

  function retriggerAnimation(el) {
    if (!el || motionQuery.matches) return;
    el.style.animation = 'none';
    void el.offsetWidth;
    el.style.animation = '';
  }

  // The strip renders every product in the collection three times over and
  // always centres within the middle copy, so there is a real neighbour on both
  // sides no matter which index is active (a single pass would leave a gap at
  // either end). The container masks its edges, so the outer slides fade out
  // rather than being clipped.
  // Repeating only earns its keep at 3+ products. With one product a repeated
  // strip shows the same mat three times; with two it flanks the centre with
  // two copies of the other one. Both read as a bug, and 16 of the 42 rows in
  // this menu have one or two products, so this is the common case rather than
  // an edge case. Those render as a plain centred group instead.
  function fanRepeats() {
    return fanItems.length >= 3 ? 3 : 1;
  }

  function buildFanStrip() {
    if (!fanArt) return;
    fanArt.innerHTML = '';
    if (fanRoot) {
      fanRoot.classList.remove('is-single', 'is-pair', 'is-strip');
    }
    if (!fanItems.length) {
      fanArt.classList.add('is-empty');
      if (fanRoot) fanRoot.classList.remove('has-art');
      return;
    }
    if (fanRoot) {
      if (fanItems.length === 1) fanRoot.classList.add('is-single');
      else if (fanItems.length === 2) fanRoot.classList.add('is-pair');
      else fanRoot.classList.add('is-strip');
    }

    const repeats = fanRepeats();
    const track = document.createElement('div');
    track.className = 'mega-menu__fan-track';
    for (let pass = 0; pass < repeats; pass += 1) {
      fanItems.forEach(function (item, i) {
        const slide = document.createElement('div');
        slide.className = 'mega-menu__fan-slide';
        if (item && item.kind === 'logo') {
          slide.classList.add('mega-menu__fan-slide--logo');
        }
        slide.setAttribute('data-fan-slide', String(i));
        if (item && item.src) {
          const img = document.createElement('img');
          img.src = item.src;
          // The strip and its visible name are one product link. Keep every
          // rotating/duplicated image decorative so the link has one concise
          // accessible name instead of repeating all four product titles.
          img.alt = '';
          // Middle pass is the visible one when repeating; with no repetition
          // every slide is on screen, so all of them load eagerly.
          img.loading = repeats === 1 || pass === 1 ? 'eager' : 'lazy';
          img.decoding = 'async';
          if (item.kind === 'logo' && item.hoverSrc) {
            img.dataset.logoSrc = item.src;
            img.dataset.hoverSrc = item.hoverSrc;
            slide.addEventListener('pointerenter', function () {
              img.src = item.hoverSrc;
              slide.classList.add('is-hover-art');
            });
            slide.addEventListener('pointerleave', function () {
              img.src = item.src;
              slide.classList.remove('is-hover-art');
            });
          }
          slide.appendChild(img);
        }
        track.appendChild(slide);
      });
    }
    fanArt.appendChild(track);
    fanArt.classList.remove('is-empty');
    if (fanRoot) fanRoot.classList.add('has-art');
  }

  function positionFanStrip() {
    if (!fanArt || !fanItems.length) return;
    const track = fanArt.querySelector('.mega-menu__fan-track');
    if (!track) return;
    const slides = track.children;
    const count = fanItems.length;
    const active = fanIndex % count;
    // Centre within the middle repetition when repeating; otherwise the strip
    // holds exactly one copy, so the active index is the target directly.
    const target = fanRepeats() === 3 ? count + active : active;
    const slide = slides[target];
    if (!slide) return;

    for (let i = 0; i < slides.length; i += 1) {
      slides[i].classList.toggle('is-current', i === target);
    }
    const offset = slide.offsetLeft + slide.offsetWidth / 2 - fanArt.clientWidth / 2;
    track.style.transform = 'translateX(' + -Math.round(offset) + 'px)';
  }

  function renderFanFrame() {
    if (!fanArt) return;
    const item = fanItems.length ? fanItems[fanIndex % fanItems.length] : null;
    const title = item && item.title ? item.title : '';
    const label =
      item && item.kind === 'logo' ? String(title || '').trim() : quotedArtTitle(title);

    if (fanLink) {
      const href = item && item.url ? item.url : fanFallbackUrl;
      if (href) {
        fanLink.hidden = false;
        fanLink.href = href;
        fanLink.setAttribute(
          'aria-label',
          (strings.shopAll + ' ' + (label || fanFallbackLabel)).trim()
        );
      } else {
        fanLink.hidden = true;
        fanLink.removeAttribute('href');
        fanLink.removeAttribute('aria-label');
      }
    }

    if (!fanArt.querySelector('.mega-menu__fan-track')) buildFanStrip();
    positionFanStrip();

    if (fanName) {
      if (label) {
        fanName.hidden = false;
        fanName.textContent = label;
        retriggerAnimation(fanName);
      } else {
        fanName.hidden = true;
        fanName.textContent = '';
      }
    }

    retriggerAnimation(fanArt);
  }

  function startFan() {
    clearFanTimer();
    // The panel ships visibility:hidden/opacity:0, but rendering the fan here
    // still injects image elements and makes the browser fetch full-size
    // product photography on every page load, for a menu most visitors never
    // open. openMenu() calls back in, so nothing is lost by waiting.
    if (!isOpen) return;
    fanIndex = 0;
    renderFanFrame();
    if (motionQuery.matches || fanItems.length < 2) return;
    fanTimer = window.setInterval(function () {
      fanIndex += 1;
      renderFanFrame();
      if (mobileThumb && fanItems.length) {
        const item = fanItems[fanIndex % fanItems.length];
        const src = item && item.src ? item.src : '';
        mobileThumb.innerHTML = thumbMarkup(src);
      }
    }, fanIntervalMs);
  }

  function renderTicker(row) {
    if (!tickerTrack || !tickerLabel) return;
    const name = row.getAttribute('data-mega-key') || '';
    const group = row.getAttribute('data-group') || 'category';
    const related = parseJsonAttr(row, 'data-related', []);
    const isCategory = group === 'category';

    tickerLabel.innerHTML =
      '<strong>' +
      esc(name) +
      '</strong> ' +
      (isCategory ? strings.containsMatsFrom : strings.matsAppearIn);

    const licensedNames = rowsForScope('licensed').map(function (r) {
      return r.getAttribute('data-mega-key');
    });

    const items = (related.length ? related : []).map(function (label) {
      const isLicensed = licensedNames.indexOf(label) !== -1;
      return (
        '<span class="mega-menu__ticker-item">' +
        '<span class="mega-menu__ticker-dot' +
        (isLicensed ? ' mega-menu__ticker-dot--gold' : '') +
        '"></span>' +
        esc(label) +
        '</span>'
      );
    });

    if (!items.length) {
      tickerTrack.innerHTML = '';
      return;
    }

    const html = items.join('') + items.join('');
    tickerTrack.innerHTML = html;
    tickerTrack.style.animation = 'none';
    void tickerTrack.offsetWidth;
    tickerTrack.style.animation = '';
  }

  function bumpStageEnter() {
    if (!stageCopy || motionQuery.matches) return;
    stageCopy.classList.remove('is-entering');
    void stageCopy.offsetWidth;
    stageCopy.classList.add('is-entering');
    window.setTimeout(function () {
      stageCopy.classList.remove('is-entering');
    }, 700);
  }

  function renderStage(row, options) {
    if (!row || !titleEl || !kickEl) return;
    const name = row.getAttribute('data-mega-key') || '';
    const group = row.getAttribute('data-group') || 'category';
    const count = row.getAttribute('data-count') || '0';
    const logo = row.getAttribute('data-logo') || '';
    const limited = row.getAttribute('data-limited') === 'true';
    const ends = row.getAttribute('data-ends') || '';
    const isCategory = group === 'category';

    fanFallbackUrl = row.getAttribute('href') || row.href || collectionsUrl;
    fanFallbackLabel = name || strings.shopAll;

    titleEl.innerHTML = '';
    /* The big title is ALWAYS the text name (Aaron 2026-08-31: "Always show
       the text title in the mega menu for creators, with their logo somewhere
       else"). A partner's logo now rides above the name as a compact mark
       instead of replacing it. */
    if (!isCategory && logo) {
      const img = document.createElement('img');
      img.className = 'mega-menu__stage-title-mark';
      img.src = logo;
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      titleEl.appendChild(img);
    }
    const text = document.createElement('div');
    const titleLength = Array.from(name.trim()).length;
    const longestTitleWord = name
      .trim()
      .split(/\s+/)
      .reduce(function (longest, word) {
        return Math.max(longest, Array.from(word).length);
      }, 0);
    const extraLongTitle = titleLength > 28 || longestTitleWord > 18;
    const longTitle = extraLongTitle || titleLength > 18 || longestTitleWord > 12;
    text.className =
      'mega-menu__stage-title-text' +
      (limited ? ' is-gold' : '') +
      (longTitle ? ' is-long' : '') +
      (extraLongTitle ? ' is-extra-long' : '');
    text.textContent = name;
    titleEl.appendChild(text);

    /* Stage CTA follows the row it is describing, and names it: "Shop Limited
       Editions", not a generic "All Designs". It only appears once the visitor
       has actually picked a row \u2014 opening the menu and switching scope both
       land on a default row nobody chose, and those pass options.auto. */
    if (stageCta) {
      if (options && options.auto) {
        stageCta.hidden = true;
        stageCta.removeAttribute('href');
      } else {
        stageCta.href = row.getAttribute('href') || row.href || collectionsUrl;
        stageCta.textContent = strings.shopName
          .replace('__NAME__', name)
          .replace('{{ name }}', name);
        stageCta.hidden = false;
        stageCta.classList.toggle('mega-menu__stage-cta--gold', limited);
      }
    }

    kickEl.classList.toggle('is-gold', limited || group === 'licensed');
    if (isCategory) {
      kickEl.innerHTML =
        '<span class="mega-menu__stage-kick-muted">' +
        esc(count) +
        '</span> ' +
        strings.deskmatsLive;
    } else if (group === 'licensed') {
      kickEl.innerHTML =
        '<span class="mega-menu__stage-kick-muted">' +
        esc(count) +
        '</span> ' +
        strings.deskmatsLive +
        ' <span> — ' +
        strings.officiallyLicensed +
        '</span>';
    } else {
      kickEl.innerHTML =
        strings.creatorCollab +
        ' · <span class="mega-menu__stage-kick-muted">' +
        esc(count) +
        '</span> ' +
        strings.deskmatsLive;
    }

    if (chipEl) {
      if (ends && group === 'creators') {
        chipEl.hidden = false;
        chipEl.innerHTML =
          '<span class="mega-menu__stage-chip-badge">' +
          strings.limitedEdition +
          '</span>' +
          '<span class="mega-menu__stage-chip-label">' +
          strings.dropEndsIn +
          '</span>' +
          '<span class="mega-menu__stage-chip-cd" data-mega-countdown data-ends="' +
          escAttr(ends) +
          '"></span>';
        const chipCd = chipEl.querySelector('[data-mega-countdown]');
        if (chipCd) {
          const t = parseEnds(ends);
          chipCd.textContent = Number.isNaN(t) ? '' : formatCountdown(t - Date.now(), 'full');
        }
      } else {
        chipEl.hidden = true;
        chipEl.innerHTML = '';
      }
    }

    fanItems = normalizeFanItems(parseJsonAttr(row, 'data-fan', []));

    /* data-fan-lead promotes one mat to the front of the fan. Fan order
       otherwise follows the collection, which is not always the order worth
       leading with — Cherry Blossom opened on its worst seller. Matched on the
       title or the filename so it survives the collection being re-sorted. */
    const fanLead = (row.getAttribute('data-fan-lead') || '').toLowerCase();
    if (fanLead && fanItems.length > 1) {
      const leadAt = fanItems.findIndex(function (item) {
        const title = String((item && item.title) || '').toLowerCase();
        const src = String((item && item.src) || '').toLowerCase();
        return title.indexOf(fanLead) !== -1 || src.indexOf(fanLead.replace(/\s+/g, '_')) !== -1 || src.indexOf(fanLead) !== -1;
      });
      if (leadAt > 0) fanItems.unshift(fanItems.splice(leadAt, 1)[0]);
    }
    bgSources = normalizeBgSources(parseJsonAttr(row, 'data-bg', []), fanItems);

    if (fanCaption) {
      fanCaption.textContent = strings.freshIn
        .replace('__NAME__', name)
        .replace('{{ name }}', name);
      fanCaption.hidden = fanItems.length > 0;
    }
    if (fanArt) fanArt.innerHTML = '';
    startFan();
    startBgRotation(true);
    renderTicker(row);
    bumpStageEnter();

    if (mobileName) mobileName.textContent = name;
    if (mobileMeta) {
      mobileMeta.textContent =
        count + (Number(count) === 1 ? ' design' : ' designs');
    }
    if (mobileThumb) {
      const src = fanItems[0] && fanItems[0].src ? fanItems[0].src : '';
      mobileThumb.innerHTML = thumbMarkup(src);
    }
    if (mobileHero) {
      const href = row.getAttribute('href') || row.href || collectionsUrl;
      mobileHero.setAttribute('href', href);
      mobileHero.setAttribute(
        'aria-label',
        (strings.shopAll + ' ' + name).trim()
      );
    }
  }

  function activateRow(row, options) {
    if (!row) return;
    const scope = currentScope;
    const rows = rowsForScope(scope);
    rows.forEach(function (link) {
      link.classList.toggle('is-active', link === row);
    });
    activeRow = row;
    remembered[scope] = row.getAttribute('data-mega-key');
    setGhost(row.getAttribute('data-mega-media-key'), row.getAttribute('data-group') === 'category');
    if (!(options && options.skipStage)) {
      renderStage(row, { auto: Boolean(options && options.auto) });
    }
  }

  function defaultRowForScope(scope) {
    const rows = rowsForScope(scope);
    if (!rows.length) return null;
    const key = remembered[scope];
    if (key) {
      const match = rows.find(function (row) {
        return row.getAttribute('data-mega-key') === key;
      });
      if (match) return match;
    }
    const visible = rows.find(function (row) {
      const item = row.closest('.mega-menu__row-item');
      return !item || !item.hasAttribute('hidden');
    });
    return visible || rows[0];
  }

  function sortRowsAz(scope) {
    // CEO 2026-08-02: Creators list was block-order then appeared to restart
    // mid-alphabet. Keep one continuous A–Z by display name. Rows already in
    // Ending Soonest stay in the DOM (hidden) for stage activation.
    //
    // 2026-08-07: extended to the licensed scope. Its order comes from the
    // shop-all-collections menu or the category_hub_subcollections metafield —
    // both store data, and neither alphabetised — so the section's block_order
    // cannot fix it. Sorting here makes the rendered list A–Z whatever the
    // upstream source order is, without touching store content.
    const list = lists[scope];
    if (!list) return;
    const ul = list.querySelector('[data-mega-sort-az]');
    if (!ul || ul.dataset.sortedAz === '1') return;
    const items = Array.from(ul.querySelectorAll(':scope > .mega-menu__row-item')).filter(
      function (item) {
        return (
          !item.classList.contains('mega-menu__row-item--ending-only') &&
          !item.classList.contains('mega-menu__row-item--group-head')
        );
      }
    );
    if (items.length < 2) return;

    const byName = function (a, b) {
      const an = (a.querySelector('[data-mega-key]') || a).getAttribute('data-mega-key')
        || a.textContent
        || '';
      const bn = (b.querySelector('[data-mega-key]') || b).getAttribute('data-mega-key')
        || b.textContent
        || '';
      return an.localeCompare(bn, undefined, { sensitivity: 'base' });
    };

    /* Creators is TWO lists sharing one panel: streamers, then artist collabs
       (Aaron, team doc: keep them apart with the gold "Current Artist
       Collaborations" divider — "I just want people to not get confused when it
       goes from Z to A"). Each group sorts A–Z on its own; the divider li,
       excluded from `items` above, is re-seated between them. Scopes without
       artist rows fall through to the single-list branch untouched. */
    const artists = items.filter(function (item) {
      return !!item.querySelector('[data-artist-collab]');
    });
    if (artists.length) {
      const base = items.filter(function (item) {
        return !item.querySelector('[data-artist-collab]');
      });
      base.sort(byName).forEach(function (item) {
        ul.appendChild(item);
      });
      const head = ul.querySelector(':scope > .mega-menu__row-item--group-head');
      if (head) ul.appendChild(head);
      artists.sort(byName).forEach(function (item) {
        ul.appendChild(item);
      });
    } else {
      items.sort(byName).forEach(function (item) {
        ul.appendChild(item);
      });
    }
    ul.dataset.sortedAz = '1';
  }

  function setScope(scope, options) {
    const next =
      scope === 'licensed' || scope === 'creators' ? scope : 'categories';
    const focusTab = options && options.focusTab;
    currentScope = next;
    menu.setAttribute('data-mega-scope', next);

    scopeTabs.forEach(function (tab) {
      const selected = tab.getAttribute('data-mega-scope') === next;
      tab.classList.toggle('is-active', selected);
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.setAttribute('tabindex', selected ? '0' : '-1');
      if (selected && focusTab) tab.focus({ preventScroll: true });
    });

    Object.keys(lists).forEach(function (key) {
      const list = lists[key];
      if (!list) return;
      const active = key === next;
      list.classList.toggle('is-active', active);
      list.hidden = !active;
      if (active) list.removeAttribute('hidden');
      else list.setAttribute('hidden', '');
    });

    /* All three scopes sort A–Z. Categories was the one Aaron kept re-reporting
       ("still not in alphabetical order") — it rendered in block order while the
       other two tabs were already sorted. */
    sortRowsAz(next);

    clearHoverTimer();
    motion.stageTX = 0;
    motion.stageTY = 0;
    startMotionLoop();
    if (listsScroll) listsScroll.scrollTop = 0;
    /* auto: this row is a fallback, not a choice — the stage CTA stays hidden
       until the visitor points at one themselves. */
    activateRow(defaultRowForScope(next), { auto: true });
  }

  function syncTriggers(expanded) {
    triggers.forEach(function (trigger) {
      trigger.setAttribute('aria-controls', 'megaMenu');
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.classList.toggle('mega-menu-trigger--active', expanded);
    });
  }

  function openMenu(opener) {
    if (isExiting) return;
    currentOpener = opener || currentOpener || triggers[0] || null;
    previousBodyOverflow = document.body.style.overflow;
    setScope('categories');
    sortEndingRows();
    startCountdowns();
    menu.classList.remove('is-exiting');
    isOpen = true;
    menu.inert = false;
    menu.removeAttribute('inert');
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    // Measure the scrollbar before locking scroll, so the gutter can be
    // reserved and the page does not slide sideways during the fade.
    const scrollbarW = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty(
      '--mega-scrollbar-gutter',
      (scrollbarW > 0 ? scrollbarW : 0) + 'px'
    );
    document.documentElement.classList.add('mega-menu-open');
    syncTriggers(true);
    document.body.style.overflow = 'hidden';
    dispatchMenuEvent('megamenu:open');
    startMotionLoop();
    // First open is where the fan and backdrop actually get built; the row
    // render that normally does this ran while the menu was still closed.
    if (activeRow) {
      startFan();
      startBgRotation(true);
    }
    window.requestAnimationFrame(function () {
      closeButton?.focus({ preventScroll: true });
    });
  }

  function closeMenu(restoreFocus) {
    if (!isOpen || isExiting) return;
    isOpen = false;
    clearHoverTimer();
    clearExitTimer();
    clearFanTimer();
    clearBgTimer();
    clearCountdownTimer();
    resetMotionSurfaces();
    menu.classList.remove('is-open', 'is-exiting');
    menu.setAttribute('aria-hidden', 'true');
    menu.inert = true;
    menu.setAttribute('inert', '');
    document.documentElement.classList.remove('mega-menu-open');
    syncTriggers(false);
    document.body.style.overflow = previousBodyOverflow;
    dispatchMenuEvent('megamenu:close');
    if (restoreFocus !== false && currentOpener && currentOpener.isConnected) {
      window.setTimeout(function () {
        currentOpener.focus({ preventScroll: true });
      }, 0);
    }
  }

  function navigateWithExit(href) {
    if (!href) return;
    if (motionQuery.matches || !isOpen) {
      closeMenu(false);
      if (window.EpicPageLoader) window.EpicPageLoader.show({ immediate: true });
      window.location.assign(href);
      return;
    }

    isExiting = true;
    clearExitTimer();
    clearFanTimer();
    clearBgTimer();
    clearCountdownTimer();
    resetMotionSurfaces();
    menu.classList.add('is-exiting');
    document.documentElement.classList.remove('mega-menu-open');
    syncTriggers(false);
    dispatchMenuEvent('megamenu:close');

    exitTimer = window.setTimeout(function () {
      exitTimer = null;
      isOpen = false;
      isExiting = false;
      menu.classList.remove('is-open', 'is-exiting');
      menu.setAttribute('aria-hidden', 'true');
      menu.inert = true;
      menu.setAttribute('inert', '');
      document.body.style.overflow = previousBodyOverflow;
      if (window.EpicPageLoader) window.EpicPageLoader.show({ immediate: true });
      window.location.assign(href);
    }, exitDuration);
  }

  function focusableElements() {
    return Array.from(
      menu.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (element) {
      return !element.hidden && !element.closest('[hidden]') && element.getClientRects().length > 0;
    });
  }

  function isModifiedClick(event) {
    return (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    );
  }

  if (scopeList) {
    scopeList.addEventListener('click', function (event) {
      const tab = event.target.closest ? event.target.closest('[data-mega-scope]') : null;
      if (!tab || !scopeList.contains(tab)) return;
      setScope(tab.getAttribute('data-mega-scope'));
    });

    scopeList.addEventListener('keydown', function (event) {
      if (
        event.key !== 'ArrowLeft' &&
        event.key !== 'ArrowRight' &&
        event.key !== 'Home' &&
        event.key !== 'End'
      ) {
        return;
      }
      if (!scopeTabs.length) return;
      event.preventDefault();
      const currentIndex = scopeTabs.findIndex(function (tab) {
        return tab.getAttribute('aria-selected') === 'true';
      });
      let nextIndex = currentIndex < 0 ? 0 : currentIndex;
      if (event.key === 'ArrowLeft') {
        nextIndex = (currentIndex - 1 + scopeTabs.length) % scopeTabs.length;
      } else if (event.key === 'ArrowRight') {
        nextIndex = (currentIndex + 1) % scopeTabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = scopeTabs.length - 1;
      }
      setScope(scopeTabs[nextIndex].getAttribute('data-mega-scope'), { focusTab: true });
    });
  }

  Object.keys(lists).forEach(function (scope) {
    rowsForScope(scope).forEach(function (link) {
      link.addEventListener('pointerenter', function (event) {
        if (!hoverQuery.matches || event.pointerType === 'touch') return;
        if (currentScope !== scope) return;
        clearHoverTimer();
        hoverTimer = window.setTimeout(function () {
          hoverTimer = null;
          if (link.matches(':hover')) activateRow(link);
        }, hoverIntentDelay);
      });
      link.addEventListener('pointerleave', clearHoverTimer);
      link.addEventListener('focus', function () {
        if (currentScope === scope) activateRow(link);
      });
    });
  });

  endingRows.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const key = btn.getAttribute('data-target-key');
      setScope('creators');
      const match = allRowsForScope('creators').find(function (row) {
        return row.getAttribute('data-mega-key') === key;
      });
      if (match) activateRow(match);
    });
  });

  if (stagePanel) {
    stagePanel.addEventListener(
      'pointermove',
      function (event) {
        if (!fancyMotionEnabled() || !isOpen) return;
        const rect = stagePanel.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        motion.stageTX = (event.clientX - rect.left) / rect.width - 0.5;
        motion.stageTY = (event.clientY - rect.top) / rect.height - 0.5;
        startMotionLoop();
      },
      { passive: true }
    );
    stagePanel.addEventListener('pointerleave', function () {
      motion.stageTX = 0;
      motion.stageTY = 0;
      /* Required now that the loop idles: without this the layers would freeze
         wherever the pointer left them instead of easing back to centre. */
      startMotionLoop();
    });
  }

  if (closeButton) {
    menu.addEventListener(
      'pointermove',
      function (event) {
        if (!fancyMotionEnabled() || !isOpen) return;
        const rect = closeButton.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2 - motion.closeX;
        const centerY = rect.top + rect.height / 2 - motion.closeY;
        const dx = event.clientX - centerX;
        const dy = event.clientY - centerY;
        const distance = Math.hypot(dx, dy);
        const reach = 120;
        if (distance < reach) {
          const strength = 1 - distance / reach;
          motion.closeTX = Math.max(-10, Math.min(10, dx * 0.3 * strength));
          motion.closeTY = Math.max(-10, Math.min(10, dy * 0.3 * strength));
        } else {
          motion.closeTX = 0;
          motion.closeTY = 0;
        }
        startMotionLoop();
      },
      { passive: true }
    );
    menu.addEventListener('pointerleave', function () {
      motion.closeTX = 0;
      motion.closeTY = 0;
      startMotionLoop();
    });
  }

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      if (isExiting) return;
      if (isOpen) {
        currentOpener = trigger;
        closeMenu(true);
      } else {
        openMenu(trigger);
      }
    });
  });

  closeButton?.addEventListener('click', function () {
    closeMenu(true);
  });

  menu.addEventListener('click', function (event) {
    const destination = event.target.closest('a[href]');
    if (!destination || !menu.contains(destination)) return;
    if (destination.getAttribute('target') === '_blank') {
      closeMenu(true);
      return;
    }
    if (isModifiedClick(event)) {
      closeMenu(false);
      return;
    }
    // Row titles are owned by the click-to-expand preview handler below.
    // Navigating here first made every parent click leave the page before the
    // dropdown strip could open (preventDefault does not cancel sibling listeners).
    if (destination.hasAttribute('data-mega-row')) return;
    event.preventDefault();
    navigateWithExit(destination.href);
  });

  menu.addEventListener('keydown', function (event) {
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      const rows = rowsForScope(currentScope);
      if (!rows.length) return;
      const currentIndex = Math.max(
        0,
        rows.findIndex(function (row) {
          return row === activeRow;
        })
      );
      event.preventDefault();
      const nextIndex =
        event.key === 'ArrowDown'
          ? (currentIndex + 1) % rows.length
          : (currentIndex - 1 + rows.length) % rows.length;
      activateRow(rows[nextIndex]);
      rows[nextIndex].focus({ preventScroll: true });
      // preventScroll keeps the page still, but the rows list scrolls internally — without this the
      // focused row can sit outside the visible area with no indicator.
      rows[nextIndex].scrollIntoView({ block: 'nearest' });
      return;
    }

    if (event.key !== 'Tab' || !isOpen || isExiting) return;
    const focusable = focusableElements();
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isOpen && !isExiting) {
      event.preventDefault();
      closeMenu(true);
    }
  });

  hoverQuery.addEventListener('change', function () {
    if (!hoverQuery.matches) resetMotionSurfaces();
    else startMotionLoop();
  });

  motionQuery.addEventListener('change', function () {
    if (motionQuery.matches) {
      resetMotionSurfaces();
      clearFanTimer();
      clearBgTimer();
    } else {
      startMotionLoop();
      if (isOpen) {
        startFan();
        startBgRotation(false);
      }
    }
  });

  /* ── Click-to-expand product preview ──────────────────────────────────
     Clicking a row used to navigate straight to the collection. Now the first
     click expands that row into a strip of product renders (the fan bank
     already carries src/title/url per product), so a shopper can jump to a
     specific mat without loading a collection page first. Clicking the row
     again — or its name a second time — follows the original collection link,
     and the "See all" chip in the strip always does. Keyboard: Enter expands,
     Escape collapses. (Aaron 2026-08-01.)                                  */
  function closePreview(except) {
    menu.querySelectorAll('.mega-menu__preview').forEach(function (el) {
      if (el === except) return;
      el.remove();
    });
    menu.querySelectorAll('[data-mega-row][aria-expanded="true"]').forEach(function (r) {
      if (except && r === except.previousElementSibling) return;
      r.setAttribute('aria-expanded', 'false');
    });
  }

  function buildPreview(row) {
    let items = [];
    try {
      items = JSON.parse(row.getAttribute('data-fan') || '[]');
    } catch (e) {
      items = [];
    }
    items = items.filter(function (it) {
      return it && it.src && it.url;
    });
    if (!items.length) return null;

    const wrap = document.createElement('div');
    wrap.className = 'mega-menu__preview';
    const strip = document.createElement('div');
    strip.className = 'mega-menu__preview-strip';
    items.slice(0, 4).forEach(function (it) {
      const a = document.createElement('a');
      a.className = 'mega-menu__preview-item';
      a.href = it.url;
      const img = document.createElement('img');
      img.src = it.src;
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      const label = document.createElement('span');
      label.className = 'mega-menu__preview-name';
      label.textContent =
        it.kind === 'logo' ? String(it.title || '').trim() : quotedArtTitle(it.title || '');
      a.appendChild(img);
      a.appendChild(label);
      strip.appendChild(a);
    });
    wrap.appendChild(strip);
    /* Desktop keeps the stage CTA. Mobile hides that stage entirely, so the
       expanded preview needs its own explicit route to the active collection. */
    const collectionUrl = row.getAttribute('href') || row.href || collectionsUrl;
    const collectionName = row.getAttribute('data-mega-key') || '';
    const collectionCta = document.createElement('a');
    collectionCta.className = 'mega-menu__preview-all';
    collectionCta.href = collectionUrl;
    collectionCta.textContent = ('Shop all ' + collectionName).trim();
    wrap.appendChild(collectionCta);
    return wrap;
  }

  menu.addEventListener('click', function (event) {
    const row = event.target.closest ? event.target.closest('[data-mega-row]') : null;
    if (!row || !menu.contains(row)) return;
    if (isModifiedClick(event)) return;

    /* Row click goes STRAIGHT to the collection (Aaron 2026-08-31: "clicking
       on a title should not expand products, it should bring you right to
       the end") — the inline product-preview strip is retired. This replaces
       the 2026-08-01 preview-first behavior. activateRow keeps the stage and
       backdrop in sync for the exit frame on touch, where no pointerenter
       ever fired. */
    event.preventDefault();
    activateRow(row);
    navigateWithExit(row.href);
  });

  menu.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (!menu.querySelector('.mega-menu__preview')) return;
    event.stopPropagation();
    closePreview();
  });

  menu.inert = true;
  menu.setAttribute('inert', '');
  sortEndingRows();
  setScope('categories');
  syncTriggers(false);

  return { open: openMenu, close: closeMenu };
  } // end initMegaMenu

  // ── Bootstrap ─────────────────────────────────────────────────────────────
  // Inline panel (theme editor via request.design_mode, or the marker path):
  // identical behaviour to the pre-lazy build.
  const inlineMenu = document.getElementById('megaMenu');
  if (inlineMenu) {
    initMegaMenu(inlineMenu);
    return;
  }

  // Lazy panel: sections/header.liquid emitted only the placeholder. Fetch the
  // header section through the Section Rendering API on first interaction,
  // append #megaMenu to <body> (mega-menu.css is fixed-position and keys only
  // off html.mega-menu-open, so the panel needs no header ancestor; the inline
  // guard in layout/theme.liquid keeps it hidden until opened).
  const placeholder = document.getElementById('megaMenuLazy');
  if (!placeholder) return; // no header on this page: nothing to do
  const panelSrc = placeholder.getAttribute('data-mega-menu-src');
  const fallbackUrl = placeholder.getAttribute('data-collections-url') || '/collections';
  const lazyTriggers = Array.from(document.querySelectorAll(triggerSelector));
  if (!panelSrc || !lazyTriggers.length) return;

  // Pre-load a11y parity with syncTriggers(false), which cannot run yet.
  // aria-controls is intentionally absent until the panel exists (no dangling
  // IDREF); initMegaMenu's syncTriggers(false) adds it the moment it does.
  lazyTriggers.forEach(function (t) {
    t.setAttribute('aria-haspopup', 'dialog');
    t.setAttribute('aria-expanded', 'false');
  });

  let panelPromise = null; // shared in-flight/settled fetch (prefetch + click)
  let api = null; // set once initMegaMenu has run
  let opening = false; // a click is already waiting on the fetch

  function fetchPanel() {
    if (panelPromise) return panelPromise;
    panelPromise = fetch(panelSrc, { headers: { Accept: 'text/html' } })
      .then(function (response) {
        if (!response.ok) throw new Error('mega menu fragment ' + response.status);
        return response.text();
      })
      .then(function (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const panel = doc.getElementById('megaMenu');
        if (!panel) throw new Error('megaMenu missing in fragment');
        return panel;
      })
      .catch(function (error) {
        panelPromise = null; // allow the next hover/click to retry
        throw error;
      });
    return panelPromise;
  }

  function prefetch() {
    fetchPanel().catch(function () {}); // warm silently; click handles errors
  }

  function onTriggerClick(event) {
    // preventDefault runs in the target phase, before loading-screen.js's
    // document-level click listener checks event.defaultPrevented — so the
    // navigation veil does not flash for menu opens.
    event.preventDefault();
    if (api || opening) return;
    const trigger = event.currentTarget;
    opening = true;
    trigger.setAttribute('aria-busy', 'true');
    trigger.classList.add('is-loading');
    fetchPanel()
      .then(function (panel) {
        document.body.appendChild(panel);
        api = initMegaMenu(panel); // binds listeners, sets inert + closed state
        lazyTriggers.forEach(function (t) {
          t.removeEventListener('click', onTriggerClick); // init owns clicks now
        });
        api.open(trigger); // focus returns to this trigger on close
      })
      .catch(function () {
        // Graceful path: the destination the trigger already advertises.
        window.location.assign(trigger.getAttribute('href') || fallbackUrl);
      })
      .finally(function () {
        opening = false;
        trigger.removeAttribute('aria-busy');
        trigger.classList.remove('is-loading');
      });
  }

  lazyTriggers.forEach(function (t) {
    // pointerenter does not bubble; bind directly on the (server-rendered)
    // triggers. The shared promise makes "once per trigger" once globally.
    t.addEventListener('pointerenter', prefetch, { once: true });
    t.addEventListener('focusin', prefetch, { once: true });
    t.addEventListener('touchstart', prefetch, { once: true, passive: true });
    t.addEventListener('click', onTriggerClick);
  });
})();
